<template>
  <div>
    <div class="section-paragraph">
      <div v-if="!isPreview" class="md:flex hidden absolute checklist-type-change">
        <div
          class="
            w-6
            h-6
            flex
            justify-center
            items-center
            cursor-pointer
            mr-2
            border
            rounded-sm
          "
          :class="[viewType === 'grid' ? 'text-blue border-blue' : '']"
          @click="updateViewType('grid')"
        >
           <i class="fal fa-grip-vertical"></i>
        </div>
        <div
          class="
            w-6
            h-6
            flex
            justify-center
            items-center
            cursor-pointer
            mr-2
            border
            rounded-sm
          "
          :class="[viewType === 'list' ? 'text-blue border-blue' : '']"
          @click="updateViewType('list')"
        >
          <i class="fal fa-list-ul"></i>
        </div>
      </div>
      <div
        :class="[
          'flex flex-wrap -mx-2',
          viewType === 'grid' ? 'md:flex-row' : 'flex-col',
        ]"
      >
        <div
          v-for="(item, index) of list"
          :key="index"
          :class="[
            'flex item px-2 pb-4',
            viewType === 'grid' ? 'md:w-1/2' : 'w-full',
          ]"
        >
          <div
            class="
              flex
              items-center
              justify-center
              box-border
              rounded-full
              h-6
              w-6
              text-white text-xs
              bg-blue
              mr-2
            "
          >
            <span><i class="fa fa-check"></i></span>
          </div>
          <div class="flex-1" v-if="!isPreview">
            <quill-editor
              :value="item"
              :options="getQuillEditorOptions('section-paragraph')"
              @change="updateItem(index, $event)"
              @ready="onEditorReady($event)"
            ></quill-editor>
          </div>
          <div class="flex-1" v-else v-html="item"></div>
          <div class="controls invisible" v-if="!isPreview">
            <span
              class="mt-5 cursor-pointer text-grey-500"
              @click="deleteItem(index)"
              ><i class="fa fa-times font-sm"></i
            ></span>
          </div>
        </div>
      </div>
      <div
        v-if="!isPreview"
        @click="addNewItem()"
        class="text-pink md:text-xl text-base font-semibold cursor-pointer"
      >
        + Add Item
      </div>
    </div>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import quillMixin from '../../../mixins/quill';

export default {
  name: 'Checklist',
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    index: {},
    getThemeSettings: {},
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dummyContent: '<p>Lorem Ipsum Lorem Ipsum Lorem.</p>',
    };
  },
  mixins: [quillMixin],
  computed: {
    list() {
      return this.content.items;
    },
    viewType() {
      return this.content.viewType;
    },
  },
  methods: {
    updateViewType(viewType) {
      const items = cloneDeep(this.list);

      this.$emit('updateSectionContent', { viewType, items });
    },
    addNewItem() {
      const items = cloneDeep(this.list);
      items.push(cloneDeep(this.dummyContent));

      this.$emit('updateSectionContent', {
        viewType: this.viewType,
        items,
      });
    },
    updateItem(index, { html }) {
      const items = cloneDeep(this.list);
      items[index] = html;

      this.$emit('updateSectionContent', { viewType: this.viewType, items });
    },
    deleteItem(index) {
      const items = cloneDeep(this.list);
      items.splice(index, 1);

      this.$emit('updateSectionContent', { viewType: this.viewType, items });
    },
  },
};
</script>
<style lang="scss" scoped>
.item:hover .controls {
  visibility: visible;
}
.checklist-type-change {
  right: 43px;
  top: 13px;
}
</style>